import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import WorkorderService from "../../services/workorders"
import WorkorderitemService from "../../services/workorderitems";
import UserService from "../../services/users";
import Paper from "@material-ui/core/Paper"
import formattingStyle from "../../styles/formatting"
import { FormControlLabel, Checkbox } from "@material-ui/core";
const remarkStyle = {
  whiteSpace: 'pre-wrap',
  backgroundColor: '#5e6b80',
  color: '#fff'
}

//class WorkorderEdit extends React.Component {
export default function WorkorderEdit(props) {
  const [user, setUser] = useState();

  useEffect(() => {
    if (props.order.user) {
      UserService.get(props.order.user)
        .then((user) => {
          setUser(user);
        }, (err) => { })
    }
  }, [props.order])

  const save = (ev) => {
    let item = Object.assign({}, props.order);
    props.save(item)
      .then(result => { })
      .catch((ex => { }));
  }

  const update = (ev) => {
    let item = Object.assign({}, props.order);
    item[ev.target.id] = ev.target.value;
    props.update(item)
  }

  const updateRecievedInvoice = (ev) => {
    let item = Object.assign({}, props.order);
    
    item.recievedinvoice = ev.target.checked;
    console.log('New value ',item.recievedinvoice)
    props.save(item)
      .then(result => { 
        props.update(item)
      })
      .catch((ex => { }));
    
  //  props.update(item)
  //  save();
  }
  
  return (
    <React.Fragment>
      <Paper className="padding">
  {user && <React.Fragment><b>{user.firstname + ' ' + user.lastname}</b><br /><i>{UserService.getFunction(user.type)} {user.function?' - '+user.function:''}</i></React.Fragment>}
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Titel werkbon"
          type="text"
          value={props.order.name || ""}
          onChange={update}
          onBlur={save}
          fullWidth
          InputProps={{
            readOnly: (props.readonly || false),
          }}
        />
        <div style={formattingStyle.header}>Status : {WorkorderService.getStatusLabel(props.order.status)}</div>
        {(props.order.referencenr && props.order.status === 3) && <div style={formattingStyle.header}>Referentienummer : {props.order.referencenr}</div>}
        {<div style={formattingStyle.header}>Totaal : {WorkorderitemService.getTotals(props.orderitems)}</div>}
        {(UserService.currentUser().adminmodules.indexOf('workorders')>=0) && <div style={formattingStyle.header}> Factuur ontvangen: <Checkbox checked={props.order.recievedinvoice|| false} onChange={updateRecievedInvoice} name="Factuur_ontvangen" /></div>}
      </Paper>
      <br />
      {
        (props.order.status === 2 && props.order.remarks)
        && <React.Fragment><Paper style={remarkStyle} className="padding">{props.order.remarks}</Paper><br /></React.Fragment>

      }


    </React.Fragment>
  );

}
